// index.js
// src/app/routes/index.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Auth Pages
import LoginPage from '../../features/auth/pages/LoginPage';
import RegisterPage from '../../features/auth/pages/RegisterPage';
import ForgotPasswordPage from '../../features/auth/pages/ForgotPasswordPage';
import ResetPasswordPage from '../../features/auth/pages/ResetPasswordPage';

// Dashboard
import ProfilePage  from '../../features/profile/pages/ProfilePage';
import AppLayout from '../layouts/AppLayout';
import DashboardPage from '../../features/dashboard/pages/DashboardPage';

// Other feature pages (you'll create these)
import PatientListPage from '../../features/patients/pages/PatientListPage';
import PatientDetailPage from '../../features/patients/pages/PatientDetailPage';
// import VisitsPage from '../../features/visits/pages/VisitsPage';
// import MedicalRecordsPage from '../../features/medical-records/pages/MedicalRecordsPage';

// In your AppRoutes.js or routes configuration
import StockListPage from '../../features/stock/pages/StockListPage';
import StockDetailPage from '../../features/stock/pages/StockDetailPage';
import StockCreatePage from '../../features/stock/pages/StockCreatePage';
import StockEditPage from '../../features/stock/pages/StockEditPage';
import StockMovementPage from '../../features/stock/pages/StockMovementPage';
import StockIssuePage from '../../features/stock/pages/StockIssuePage';

import MedicineInventoryFeature from '../../features/medicine-inventory';

import ClinicalFeature from '../../features/clinical';


// src/app/routes/index.js (add these routes)
import StockCategoriesPage from '../../features/stock-categories/pages/StockCategoriesPage';
import UnitsPage from '../../features/units/pages/UnitsPage';
import MeasurementUnitsPage from '../../features/measurement-units/pages/MeasurementUnitsPage';
import SuppliersPage from '../../features/suppliers/pages/SuppliersPage';
import LocationsPage from '../../features/locations/pages/LocationsPage';
import ManufacturersPage from '../../features/manufacturers/pages/ManufacturersPage';
import DepartmentsPage from '../../features/departments/pages/DepartmentsPage';
import VisitsPage  from '../../features/visits/pages/VisitsPage';

// Add to your private routes

//Medicine Reports
import ReportsDashboardPage from '../../features/reports/pages/ReportsDashboardPage';
import IssueReportPage from '../../features/reports/pages/IssueReportPage';
import StockReportPage from '../../features/reports/pages/StockReportPage';
import LowStockReportPage from '../../features/reports/pages/LowStockReportPage';
import ExpiryReportPage from '../../features/reports/pages/ExpiryReportPage';
import MovementSummaryPage from '../../features/reports/pages/MovementSummaryPage';
import TopConsumedPage from '../../features/reports/pages/TopConsumedPage'; 
import StockMedicinesPage from '../../features/medicines/pages/StockMedicinesPage';
import AttendanceReportPage from '../../features/reports/pages/AttendanceReportPage';
import CommandCentreDashboard from '../../features/reports/pages/CommandCentreDashboard';
import HeatmapDashboard from '../../features/reports/pages/HeatmapDashboard';
import MapDashboard from '../../features/reports/pages/MapDashaboard';
import UsersPage from '../../features/master-data/pages/UsersPage';


const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return !isAuthenticated ? children : <Navigate to="/dashboard" />;
};

const AppRoutes = () => {
  return (
    <Routes>

      {/* Public Routes */}
      <Route path="/login" element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      } />

      <Route path="/register" element={
        <PublicRoute>
          <RegisterPage />
        </PublicRoute>
      } />

      <Route path="/forgot-password" element={
        <PublicRoute>
          <ForgotPasswordPage />
        </PublicRoute>
      } />

      <Route path="/reset-password/:token" element={
        <PublicRoute>
          <ResetPasswordPage />
        </PublicRoute>
      } />

      {/* Private Layout Wrapper */}
      <Route element={
        <PrivateRoute>
          <AppLayout />
        </PrivateRoute>
      }>

        {/* Default route */}
        <Route path="/" element={<DashboardPage />} />

              {/* Other routes */}
      <Route path="/profile" element={<ProfilePage />} />



      {/* Redirect to profile */}
      <Route path="/my-account" element={<Navigate to="/profile" replace />} />

        {/* Stock Routes */}
        <Route path="/stock" element={<StockListPage />} />
        <Route path="/stock/create" element={<StockCreatePage />} />
        <Route path="/stock/:id" element={<StockDetailPage />} />
        <Route path="/stock/:id/edit" element={<StockEditPage />} />
        <Route path="/stock/:id/movements" element={<StockMovementPage />} />
        <Route path="/stockissue" element={<StockIssuePage />} />


     

        <Route path="/master/categories" element={<StockCategoriesPage />} />
        <Route path="/master/medicines" element={<StockMedicinesPage />} />
        <Route path="/master/units" element={<UnitsPage />} />
        <Route path="/master/munits" element={<MeasurementUnitsPage />} />
        <Route path="/master/suppliers" element={<SuppliersPage />} />
        <Route path="/master/locations" element={<LocationsPage />} />
        <Route path="/master/manufacturers" element={<ManufacturersPage />} />
        <Route path="/master/departments" element={<DepartmentsPage />} />

      <Route path="/reports" element={<ReportsDashboardPage />} />
      <Route path="/reports/issue" element={<IssueReportPage />} />
      <Route path="/reports/stock" element={<StockReportPage />} />
      <Route path="/reports/low-stock" element={<LowStockReportPage />} />
      <Route path="/reports/expiry" element={<ExpiryReportPage />} />
      <Route path="/reports/movement" element={<MovementSummaryPage />} />
      <Route path="/reports/top-consumed" element={<TopConsumedPage />} />
      <Route path="/reports/attendance" element={<AttendanceReportPage />} />
      <Route path="/reports/attendance2" element={<CommandCentreDashboard />} />
      <Route path="/reports/attendance3" element={<HeatmapDashboard />} />
      <Route path="/reports/map" element={<MapDashboard />} />


        {/*Patient Routes*/}
        <Route path="/patients" element={<PatientListPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/patients/:id" element={<PatientDetailPage />} />

        <Route path="/visits" element={<VisitsPage />} />
        <Route path="/" element={<Navigate to="/inventory" replace />} />

          <Route path="/inventory/*" element={<MedicineInventoryFeature />} />

          <Route path="/clinical/*" element={<ClinicalFeature />} />
          <Route path="/" element={<Navigate to="/clinical" replace />} />

         
         

      </Route>
      

      {/* 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />

    </Routes>
  );
};
export default AppRoutes;